export default __webpack_public_path__ + "static/media/local.40f5cbe9.png";